import {
    GameKind,
    RecentlyPlayedGame,
} from './types';

export function isGenericCasinoGameEntry(entry: RecentlyPlayedGame): entry is Exclude<RecentlyPlayedGame, {
    id: number;
    kind: 'lotto';
}> {
    return entry.kind === GameKind.CasinoGeneric;
}

export function isV2Entry(entry: number | RecentlyPlayedGame): entry is number {
    return typeof entry === 'number';
}
